import React from "react";
import MixedLoginContainer from "../containers/MixedLoginContainer";

const WebMixedLoginPage = ({ ...props }) => {
    return (
        <MixedLoginContainer {...props} />
    );
}

export default WebMixedLoginPage;